const MOBILE_EAGER_IMAGE_COUNT = 2;
const DESKTOP_EAGER_IMAGE_COUNT = 4;

const getImageLoadingProps = ({ index, isMediumViewportOrGreater }) => {
  const eagerImageCount =
    isMediumViewportOrGreater === false
      ? MOBILE_EAGER_IMAGE_COUNT
      : DESKTOP_EAGER_IMAGE_COUNT;
  const isAboveTheFold = index < eagerImageCount;

  return {
    loading: isAboveTheFold ? "eager" : "lazy",
    fetchPriority: isAboveTheFold ? "high" : undefined
  };
};

export default getImageLoadingProps;
